import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { TableHead } from "@mui/material";
const getElementOffsetTop = (element) => {
    let actualOffset = element["offsetTop"];
    let current = element.offsetParent;
    while (current != null) {
        actualOffset += current["offsetTop"];
        current = current.offsetParent;
    }
    return actualOffset;
};
export const StickyTableHead = (props) => {
    const { stickyHeaderToRef, sx, children } = props;
    const stickyHeaderRef = useRef();
    const [refScrollTop, setRefScrollTop] = useState(0);
    const [offset, setOffset] = useState();
    useEffect(() => {
        if ((stickyHeaderToRef === null || stickyHeaderToRef === void 0 ? void 0 : stickyHeaderToRef.current) && !offset) {
            setOffset(getElementOffsetTop(stickyHeaderRef === null || stickyHeaderRef === void 0 ? void 0 : stickyHeaderRef.current) - getElementOffsetTop(stickyHeaderToRef === null || stickyHeaderToRef === void 0 ? void 0 : stickyHeaderToRef.current));
        }
    }, [stickyHeaderRef]);
    useEffect(() => {
        var _a;
        (_a = stickyHeaderToRef === null || stickyHeaderToRef === void 0 ? void 0 : stickyHeaderToRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("scroll", () => onRefscroll(offset));
    }, [offset]);
    const onRefscroll = (offset) => {
        var _a, _b, _c;
        const parentHeight = (stickyHeaderRef === null || stickyHeaderRef === void 0 ? void 0 : stickyHeaderRef.current) && stickyHeaderRef.current["parentElement"]["clientHeight"] || 0;
        const headerHeight = (stickyHeaderRef === null || stickyHeaderRef === void 0 ? void 0 : stickyHeaderRef.current) && stickyHeaderRef.current["clientHeight"] || 0;
        setRefScrollTop(((_a = stickyHeaderToRef === null || stickyHeaderToRef === void 0 ? void 0 : stickyHeaderToRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) < offset
            ? 0
            : (parentHeight - headerHeight + offset) < ((_b = stickyHeaderToRef === null || stickyHeaderToRef === void 0 ? void 0 : stickyHeaderToRef.current) === null || _b === void 0 ? void 0 : _b.scrollTop)
                ? (parentHeight - headerHeight)
                : ((_c = stickyHeaderToRef === null || stickyHeaderToRef === void 0 ? void 0 : stickyHeaderToRef.current) === null || _c === void 0 ? void 0 : _c.scrollTop) - offset);
    };
    return (_jsx(TableHead, Object.assign({}, props, { sx: Object.assign(Object.assign({}, sx), { width: "inherit", display: "inherit", position: "absolute", top: `${refScrollTop}px` }), ref: stickyHeaderRef, children: children })));
};
export default StickyTableHead;
//# sourceMappingURL=StickyTableHead.js.map